export const formatDateT = (dateTime) => {
  if (!dateTime) return null;

  // Regex to check if date is already in yyyy-mm-dd format
  const yyyyMmDdRegex = /^\d{4}-\d{2}-\d{2}$/;
  const dateTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/; // Matches DD/MM/YYYY HH:mm

  if (yyyyMmDdRegex.test(dateTime)) {
    return `${dateTime}T00:00:00`; // If already YYYY-MM-DD, return with default time
  }

  // Handle DD/MM/YYYY HH:mm format
  const match = dateTime.match(dateTimeRegex);
  if (match) {
    const [, day, month, year, hour, minute] = match;
    return `${year}-${month}-${day}T${hour}:${minute}:00`;
  }

  // Handle formats like DD-MM-YYYY, MM-DD-YYYY, DD/MM/YYYY, MM/DD/YYYY
  const dateParts = dateTime.split(/[-/ ]/); // Split by "-", "/", or space
  if (dateParts.length >= 3) {
    let [first, second, third] = dateParts;
    let time = "00:00"; // Default time

    if (dateParts.length > 3) {
      // Extract time if available
      time = `${dateParts[3]}:${dateParts[4] || "00"}`;
    }

    if (first.length === 4) {
      // If first part is 4 digits, assume YYYY-MM-DD
      return `${first}-${second}-${third}T${time}:00`;
    } else {
      // Otherwise, assume DD-MM-YYYY or MM-DD-YYYY and convert to YYYY-MM-DD
      return `${third}-${second}-${first}T${time}:00`;
    }
  }

  return null; // Return null if the format is unrecognized
};

export const deformatDateT = (dateTime) => {
  if (!dateTime) return null;

  // Regular expression to match yyyy-mm-ddTHH:mm:ss format (any time)
  const dateTimeRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;

  // Check if the dateTime matches the expected format
  if (!dateTimeRegex.test(dateTime)) return null;

  // Extract the date part before 'T'
  const [year, month, day] = dateTime.split("T")[0].split("-");

  // Return the date in dd/mm/yyyy format
  return `${day}/${month}/${year}`;
};

export const deformatMonthT = (dateTime) => {
  if (!dateTime) return null;

  // Regular expression to match yyyy-mm-ddT00:00:00 format
  const timeRegex = /^\d{4}-(\d{2})-\d{2}T\d{2}:\d{2}:\d{2}$/;

  // Match the time portion and return only the time part
  const match = dateTime.match(timeRegex);
  if (!match) return null;

  return match[1]; // Return HH:mm part of the time
};

export const deformatYearT = (dateTime) => {
  if (!dateTime) return null;

  // Regular expression to match yyyy-mm-ddT00:00:00 format
  const timeRegex = /^(\d{4})-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;

  // Match the time portion and return only the time part
  const match = dateTime.match(timeRegex);
  if (!match) return null;

  return match[1]; // Return HH:mm part of the time
};

export const removePound = (value) => {
  return value.replace(/£/g, "");
};
